/*
 * @Author: luting
 * @Date: 2022-05-07 16:42:27
 * @lastEditors: luting
 * @LastEditTime: 2022-05-09 16:32:37
 */
import messages from './messages';
import { MessageDescriptor } from 'react-intl';

interface ITimeOptions {
  id: number;
  value: number;
  label: MessageDescriptor;
}

export const timeOptions: ITimeOptions[] = [
  {
    id: 1,
    value: 0,
    label: messages.manual,
  },
  {
    id: 2,
    value: 1,
    label: messages.auto,
  },
];
